import { createApp, inject, provide, $emit } from "vue";
import menuLateral from "./MenuLateral.vue";

const app = createApp({
  components: {
    "menu-lateral": menuLateral,
  },
}).mount("#menu-lateral-content");
